import React from 'react'

// Friendly placeholder for lists with no items yet
const EmptyState = ({ icon = 'file-tray-outline', title = 'Nothing here yet', text, action }) => {
  return (
    <div className="bl-empty" role="status">
      <div className="bl-empty__icon">
        <ion-icon name={icon} aria-hidden="true"></ion-icon>
      </div>
      <h3>{title}</h3>
      {text && <p className="mb-0">{text}</p>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  )
}

export default EmptyState
